import commonApi from './CommonApi.js';
var qs = require('query-string');

export default {
    getAll: async (parameter) => {
        return await commonApi().get('/v1/case-laws/getAll', { params: parameter })
            .then((response) => {
                if (response.status == 200) {
                    return response.data;
                } else {
                    console.log(response);
                    return {};
                }
            })
            .catch((error) => {
                console.log(error)
                return {};
            });
    },
    search: async (viewModel) => {
        //return await commonApi().get('/v1/case-laws/search', {
        //    params: parameter,
        //    paramsSerializer: (params) => {
        //        return qs.stringify(params);
        //    }
        //})
        //    .then((response) => {
        //        if (response.status == 200) {
        //            return response.data;
        //        } else {
        //            console.log(response);
        //            return {};
        //        }
        //    })
        //    .catch((error) => {
        //        console.log(error)
        //        return {};
        //    });


        return await commonApi().post('/v1/case-laws/search', viewModel)
            .then((response) => {
                if (response.status == 200) {
                    return response.data;
                } else {
                    console.log(response);
                    return {};
                }
            })
            .catch((error) => {
                console.log(error)
                return {};
            });
    },
    publicSearch: async (viewModel) => {
        //return await commonApi().get('/v1/case-laws/publicsearch', {
        //    params: parameter,
        //    paramsSerializer: (params) => {
        //        return qs.stringify(params);
        //    }
        //})
        //    .then((response) => {
        //        if (response.status == 200) {
        //            return response.data;
        //        } else {
        //            console.log(response);
        //            return {};
        //        }
        //    })
        //    .catch((error) => {
        //        console.log(error)
        //        return {};
        //    });

        return await commonApi().post('/v1/case-laws/publicsearch', viewModel)
            .then((response) => {
                if (response.status == 200) {
                    return response.data;
                } else {
                    console.log(response);
                    return {};
                }
            })
            .catch((error) => {
                console.log(error)
                return {};
            });
    },
    exportAllResults: async (viewModel) => {
       
        return await commonApi().post('/v1/case-laws/exportallresult', viewModel, { responseType: 'blob' })
            .then((response) => {
                if (response.status == 200) {
                    return response;
                } else {
                    console.log(response);
                    return {};
                }
            })
            .catch((error) => {
                console.log(error)
                return {};
            });
    },
    getById: async (parameters) => {
        return await commonApi().get('/v1/case-laws/getById', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    create: async (viewModel) => {
        return await commonApi().post('/v1/case-laws', viewModel)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },
    edit: async (viewModel) => {
        return await commonApi().put('/v1/case-laws', viewModel)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },
    delete: async (parameters) => {
        return await commonApi().delete('/v1/case-laws', { params: parameters })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    validateCaseDetails: async (viewModel) => {
        return await commonApi().post('/v1/case-laws/validatecasedetails', viewModel)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },
    validateContributorInformation: async (viewModel) => {
        return await commonApi().post('/v1/case-laws/validatecontributorinformation', viewModel)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },
    validateProvisionDetails: async (viewModel) => {
        return await commonApi().post('/v1/case-laws/validateprovisiondetails', viewModel)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },
    validateDecisionDetails: async (viewModel) => {
        return await commonApi().post('/v1/case-laws/validatedecisiondetails', viewModel)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },
    setStatus: async (viewModel) => {
        return await commonApi().post('/v1/case-laws/setstatus', viewModel)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },
    getDetailsById: async (parameters) => {
        return await commonApi().get('/v1/case-laws/getDetailsById', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    getDetailsHTMLById: async (parameters) => {
        return await commonApi().get('/v1/case-laws/getDetailsHTMLById', { params: parameters })
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log(error.response);
            });
    },
    downloadDetails: async (viewModel) => {

        return await commonApi().post('/v1/case-laws/downloadDetails', viewModel, { responseType: 'blob' })
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },
    sendDetailsByEmail: async (viewModel) => {

        return await commonApi().post('/v1/case-laws/sendDetailsByEmail', viewModel)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
    },
    checkDuplicate: async (parameter) => {
        return await commonApi().get('/v1/case-laws/checkduplicate', {
            params: parameter,
            paramsSerializer: (params) => {
                return qs.stringify(params);
            }
        })
            .then((response) => {
                if (response.status == 200) {
                    return response.data;
                } else {
                    console.log(response);
                    return {};
                }
            })
            .catch((error) => {
                console.log(error)
                return {};
            });
    },

    checkDuplicateCaseCitation: async (parameter) => {
        return await commonApi().get('/v1/case-laws/checkduplicatecasecitation', {
            params: parameter,
            paramsSerializer: (params) => {
                return qs.stringify(params);
            }
        })
            .then((response) => {
                if (response.status == 200) {
                    return response.data;
                } else {
                    console.log(response);
                    return {};
                }
            })
            .catch((error) => {
                console.log(error)
                return {};
            });
    },
}